(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state("Home.Tools.MarketingTracker.Kits",
                {
                    url: "/Kits",
                    component: "marketingTrackerKits",
                    PageTitle: "Marketing Tracker Kits",
                    requiredOnePermission: "OnboardingKit:Access|PlanningKit:Access",
                    resolve: {
                        annualPlanningAttemptYears: ["marketingKitApi", function (marketingKitApi) {
                            return marketingKitApi.getAnnualPlanningKitYears().then(function (years) {
                                return years;
                            }, function () {
                                console.log("no years");
                                return null;
                            });
                        }]
                    }
                });
    }]);

    app
        .component("marketingTrackerKits",
            {
                templateUrl: "App/Tools/MarketingTracker/Kits/kits-template.html",
                controller: marketingTrackerKitsController,
                bindings: {
                    annualPlanningAttemptYears: "<"
                }
            });

    marketingTrackerKitsController.$inject = ["$state", "permissionService"];
    function marketingTrackerKitsController($state, permissionService) {
        var $ctrl = this;
        $ctrl.state = $state;
        var currentYear = (new Date()).getFullYear();
        $ctrl.year = currentYear;
        $ctrl.years = [];

        if ($ctrl.annualPlanningAttemptYears !== null && $ctrl.annualPlanningAttemptYears.length > 0) {
            var latestYear = $ctrl.annualPlanningAttemptYears[0].Year;
            var earliestYear = $ctrl.annualPlanningAttemptYears.slice(-1)[0].Year;

            if (earliestYear > currentYear) {
                for (var i = parseInt(currentYear); i <= parseInt(earliestYear) + 1; i++)
                    $ctrl.years.push(parseInt(i));
            } else {
                for (var i = parseInt(earliestYear); i <= parseInt(currentYear) + 1; i++)
                    $ctrl.years.push(parseInt(i));
            }

            $ctrl.year = latestYear;
            $state.go("Home.Tools.MarketingTracker.Kits.AnnualPlanning", { "year": $ctrl.year });
        }

        else if ($ctrl.annualPlanningAttemptYears !== null && $ctrl.annualPlanningAttemptYears.length === 0) {
            for (var i = $ctrl.year; i <= currentYear + 1; i++)
                $ctrl.years.push(parseInt(i));
            console.log($ctrl.years);

            $state.go("Home.Tools.MarketingTracker.Kits.AnnualPlanning", { "year": $ctrl.year });
        }

        else {
            for (var i = $ctrl.year; i <= currentYear + 1; i++)
                $ctrl.years.push(parseInt(i));
            console.log($ctrl.years);

            $state.go("Home.Tools.MarketingTracker.Kits.Onboarding");
        }

        $ctrl.updateAnnalPlanningKitShown = function (year) {
            $state.go("Home.Tools.MarketingTracker.Kits.AnnualPlanning", { "year": year });
        };
    }

 })(window.app, window.angular); // jshint ignore:line